import React, { useState } from "react";

import { ToastContainer, toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";

import useInputChange from "hooks/useInputChange";

import { JobCreate } from "types/job.interface";
import { editJob, postJob } from "services/job.service";

import { useNavigate } from "react-router-dom";
import { Job } from "types/booking.interface";
import MyndaPreference from "pages/post-jobs/_components/MyndaPreference";
import Skills from "pages/post-jobs/_components/Skills";
import JobLocationForm from "pages/post-jobs/_components/JobLocation";
import Budget from "pages/post-jobs/_components/Budget";

import Step from "Common/Components/step";
import { CreateEmployerJob } from "types/employer.interface";
import JobDetails from "pages/post-jobs/_components/JobDetails";

interface Props {
  job: Job;
}

const EditJob = ({ job }: Props) => {
  const [currentForm, setCurrentForm] = useState(0);
  const { state, onChange, onChangeByNameValue } =
    useInputChange<CreateEmployerJob>(
      job || {
        state: "",
        lga: "",
        area: "",
        numberOfRooms: undefined,
        requiredExperience: undefined,
        gender: "",
        requiredSkills: [],
        jobType: "",
        salary: undefined,
        maxSalary: undefined,
        minSalary: undefined,
        workingHrs: undefined,
        expectedStartDate: "",
        endDate: "",
        description: "",
        phoneNumber: "",
        email: "",
        role: "",
        password: "",
        confirmPassword: "",
        country: "Nigeria",
        refferalCode: "",
        countryDialCode: "+234",
        shortCountryCode: "NG",
        category: "",
        firstName: "",
        lastName: "",
        yoe: "",
        partTimeDays: "",
        liveOutNumber: "",
        createdTime: "",
        user: "",
      }
    );

  const queryClient = useQueryClient();
  const navigation = useNavigate();

  const { mutate, isLoading } = useMutation(
    async (payload: JobCreate) => await editJob(job._id!, payload),
    {
      onSuccess(data) {
        if (data) {
          queryClient.invalidateQueries();
          toast(data.message);
          navigation("/jobs");
        }
      },
      onError(error) {
        // @ts-ignore
        toast(error?.response?.data?.message);
      },
    }
  );

  const onNext = () => {
    setCurrentForm((curr) => curr + 1);
  };

  const onBack = () => {
    setCurrentForm((curr) => curr - 1);
  };

  const handleSubmit = () => {
    mutate({
      location: state.state,
      ...state,
      salary: Number(state.salary || state.minSalary),
      requiredExperience: Number(state.requiredExperience || 0),
      numberOfRooms: state.numberOfRooms ? Number(state.numberOfRooms) : 0,
      workingHrs: state.workingHrs ? Number(state.workingHrs) : 0,
      maxSalary: state.maxSalary ? Number(state.maxSalary) : 0,
      minSalary: state.minSalary ? Number(state.minSalary) : 0,
      user: state.user ?? "",
    });
  };

  const forms = [
    <MyndaPreference
      input={state}
      onChange={onChange}
      onChangeByNameValue={onChangeByNameValue}
      onNext={onNext}
      onBack={onBack}
      key={1}
    />,
    <Skills
      input={state}
      onChange={onChange}
      onChangeByNameValue={onChangeByNameValue}
      onNext={onNext}
      onBack={onBack}
      key={2}
    />,
    <JobLocationForm
      input={state}
      onChange={onChange}
      onChangeByNameValue={onChangeByNameValue}
      onNext={onNext}
      onBack={onBack}
      key={3}
    />,

    <Budget
      input={state}
      onChange={onChange}
      onChangeByNameValue={onChangeByNameValue}
      onNext={onNext}
      onBack={onBack}
      key={4}
    />,

    <JobDetails
      input={state}
      onChange={onChange}
      onChangeByNameValue={onChangeByNameValue}
      onNext={handleSubmit}
      onBack={onBack}
      key={5}
      isLoading={isLoading}
    />,
  ];

  const steps = [
    "Who you do want to Hire?",
    "Skills?",
    "Where would they work?",
    "Pay range ?",
    "Start time?",
    "Create acount",
  ];
  return (
    <section className="bg-white  p-4 w-full ">
      <ToastContainer />
      <h1 className="text-3xl md:text-3xl font-bold text-gray-900 mb-8">
        Post Job
      </h1>
      <div className="w-full flex flex-col lg:min-w-full  lg:flex-row lg:justify-between ">
        <div className="flex justify-center lg:justify-start w-full lg:w-[30%]  lg:flex-col  bg-white py-5 lg:py-0 ">
          {steps?.map((step, index) => (
            <Step
              label={step}
              isActive={currentForm >= index}
              index={index + 1}
            />
          ))}
        </div>

        <div className=" w-full flex-1  mt-8 lg:mt-0">{forms[currentForm]}</div>
      </div>
    </section>
  );
};

export default EditJob;
